import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { Form } from "semantic-ui-react";

import RuvixxForm from "../../components/RuvixxForm";
import CaseService from "../../services/Case";
import UserService from "../../services/User";
import { filterUsersForDropdown } from "../../helpers/user";

function AssignInvestigatorsForm({ caseIds, onSuccess }) {
  const [userIds, setUserIds] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const fetchUsers = useCallback(async () => {
    const users = await UserService.getUsers();
    setAllUsers(users);
  }, []);

  // Re-filter options when allUsers or userIds change
  useEffect(() => {
    // Filter to active users + currently selected (even if deactivated)
    setUserOptions(filterUsersForDropdown(allUsers, userIds));
  }, [allUsers, userIds]);

  const handleSubmit = async () => {
    await CaseService.assignInvestigators(caseIds, userIds);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <RuvixxForm onSubmit={handleSubmit} onSuccess={onSuccess}>
      <Form.Select
        selectOnBlur={false}
        search
        multiple
        clearable
        onChange={(_, { value }) => setUserIds(value)}
        label="Investigators"
        name="investigators"
        options={userOptions}
        placeholder="Select investigators"
        value={userIds}
      />
    </RuvixxForm>
  );
}

AssignInvestigatorsForm.propTypes = {
  caseIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default AssignInvestigatorsForm;
